import { Facebook, Instagram, Phone, Mail, ArrowRight } from "lucide-react";
import { NAV, CONTACT, SERVICES, SOCIALS } from "../../data/site";
import { Logo } from "./Nav";
import { useEstimate } from "./EstimateDialog";
import { GoogleG } from "./icons/GoogleG";

const SOCIAL_ICON = { Google: GoogleG, Instagram, Facebook };

export const Footer = () => {
  const { open } = useEstimate();
  return (
    <footer className="bg-ffc-ink pt-20 text-white" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="grid gap-12 border-b border-white/10 pb-14 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Logo full />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              Residential & Commercial Property Solutions. Dependable craftsmanship, transparent
              pricing and exceptional service across {CONTACT.city}.
            </p>
            <button onClick={open} data-testid="footer-estimate-btn"
              className="btn-red mt-6 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold hover:bg-ffc-red">
              Get Free Estimate <ArrowRight className="h-4 w-4" />
            </button>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white/50">Navigate</h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm text-white/70 transition-colors hover:text-white">{n.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white/50">Popular Services</h4>
            <ul className="mt-5 space-y-3">
              {SERVICES.slice(0, 7).map((s) => (
                <li key={s.name}>
                  <a href="#services" className="text-sm text-white/70 transition-colors hover:text-white">{s.name}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white/50">Get In Touch</h4>
            <ul className="mt-5 space-y-4">
              <li>
                <a href={CONTACT.phoneHref} className="flex items-center gap-2 text-sm text-white/70 hover:text-white">
                  <Phone className="h-4 w-4 text-ffc-red" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={CONTACT.emailHref} className="flex items-center gap-2 text-sm text-white/70 hover:text-white">
                  <Mail className="h-4 w-4 text-ffc-red" /> {CONTACT.email}
                </a>
              </li>
              <li className="text-sm text-white/60">{CONTACT.hours}</li>
            </ul>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map((s) => {
                const Icon = SOCIAL_ICON[s.icon];
                return (
                  <a
                    key={s.name}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.name}
                    data-testid={`footer-social-${s.name.toLowerCase()}`}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors hover:border-ffc-red hover:bg-ffc-red hover:text-white"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 py-8 text-xs text-white/50 sm:flex-row">
          <p>© {new Date().getFullYear()} Fast Fix Charlotte LLC. Residential & Commercial Property Solutions.</p>
          <p>Licensed & Insured · {CONTACT.city}</p>
        </div>
      </div>
    </footer>
  );
};
